'use client';

import React, { Fragment, useState, JSX } from 'react';
import { Button, Collapse } from 'reactstrap';
import styles from './LeftNavi.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import { getNextLinkAttrs, SwitchableLinkProps } from '../linkList/Link';
import { useConfig } from '@ibe/components';
import YsnConfigModel from '@/Config/YsnConfigModel';

const keys = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19] as const;
type DigitType = (typeof keys)[number];
type Links = `links${DigitType}`;
type SubLinks = `subLinks${DigitType}`;
type LinkType = SwitchableLinkProps;
type Link = LinkType & { subLinks: { [key in SubLinks]: LinkType } & { '@nodes': string[] } };
type Props = {
  links: {
    [key in Links]: Link;
  } & { '@nodes': string[] };
};

const LeftNavi = (props: Props): JSX.Element => {
  const { links } = props;
  const linkCount = links['@nodes'].length;
  const [openCollapses, setOpenCollapses] = useState<Record<string, boolean>>({});
  const config = useConfig() as YsnConfigModel;

  const toggleCollapse = (id: string): void => {
    setOpenCollapses(value => ({ ...value, [id]: !value[id] }));
  };
  return !!linkCount && linkCount > 0 ? (
    <div>
      {[...Array(linkCount).keys()].map(key => {
        const link = links[`links${key}` as keyof Props['links']] as Link;
        const linkAttrsParent = getNextLinkAttrs(link, config);

        if (link) {
          const subLinksCount = (link?.subLinks?.['@nodes'] || []).length;
          return !!subLinksCount && subLinksCount > 0 ? (
            <div className={styles.leftNavi__container} key={link['@id'] as string}>
              <Button
                className={styles.leftNavi__button}
                onClick={(): void => toggleCollapse(link['@id'] as string)}
              >
                <span>{link.title}</span>
                <FontAwesomeIcon
                  className={`${styles.leftNavi__chevron} ${
                    openCollapses[link['@id'] as string] ? styles.leftNavi__chevronUp : ''
                  }`}
                  icon={faChevronDown}
                />
              </Button>
              <Collapse isOpen={openCollapses[link['@id'] as string]}>
                {[...Array(subLinksCount).keys()].map(subKey => {
                  const subLink = link.subLinks[`subLinks${subKey}` as SubLinks];
                  const linkAttrs = getNextLinkAttrs(subLink, config);
                  return (
                    <div key={subLink['@id'] as string}>
                      <Link
                        className={styles.leftNavi__link}
                        {...linkAttrs}
                        locale={linkAttrs.download === true ? false : undefined}
                      >
                        {subLink.title}
                      </Link>
                    </div>
                  );
                })}
              </Collapse>
            </div>
          ) : (
            <div className={styles.leftNavi__container} key={link['@id'] as string}>
              <Link className={styles.leftNavi__link} {...linkAttrsParent}>
                {link.title}
              </Link>
            </div>
          );
        } else {
          return <Fragment key={key} />;
        }
      })}
    </div>
  ) : (
    <></>
  );
};

export default LeftNavi;
